"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferDeathAbilityHandler = exports.DeferDeathActorAbilityFactory = exports.DeferDeathAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
class DeferDeathAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DeferDeath;
        this.__typeName = "DeferDeath";
    }
}
exports.DeferDeathAbilityArgs = DeferDeathAbilityArgs;
let DeferDeathActorAbilityFactory = class DeferDeathActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DeferDeath", "OneAllies", 8);
    }
};
DeferDeathActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DeferDeath")
], DeferDeathActorAbilityFactory);
exports.DeferDeathActorAbilityFactory = DeferDeathActorAbilityFactory;
let DeferDeathAbilityHandler = class DeferDeathAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        if (container.hasEffectOfType(selectedAlly, EffectType_1.EffectType.DeferredDeath)) {
            // Get gud noob
            sequence.push(new core_1.FloatingTextVfxStepArgs("Impossible", new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "head")));
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    duration: Duration_1.Duration.Turns(6),
                    effect: new core_2.DeferDeathEffectArgs(),
                    onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet", "behind"), "DarkMagicCircle"))
                });
            }
        });
    }
};
DeferDeathAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DeferDeath)
], DeferDeathAbilityHandler);
exports.DeferDeathAbilityHandler = DeferDeathAbilityHandler;
